import CheckInForm from '../components/CheckInForm';
import ResponseCard from '../components/ResponseCard';

export default function CheckInPage({ formData, onUpdateForm, onSubmit, response, loading, onReset }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            ✨ Wellness Check-In
          </h1>
          <p className="text-gray-600">Take a moment to reflect on how you're feeling today</p>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-6">
          <CheckInForm
            formData={formData}
            onUpdateForm={onUpdateForm}
            onSubmit={onSubmit}
            loading={loading}
          />
        </div>

        {/* Response Display */}
        {response && (
          <ResponseCard
            response={response}
            mood={formData.mood}
            stress={formData.stress}
            onReset={onReset}
          />
        )}
      </div>
    </div>
  );
}
